import { render, staticRenderFns } from "./CatalogCategorySection.vue?vue&type=template&id=3c4baad6&scoped=true&"
import script from "./CatalogCategorySection.vue?vue&type=script&lang=js&"
export * from "./CatalogCategorySection.vue?vue&type=script&lang=js&"
import style0 from "./CatalogCategorySection.vue?vue&type=style&index=0&id=3c4baad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4baad6",
  null
  
)

export default component.exports